/**
 *  Tile2
 *
 *  Created by Legman on 13/03/2017.
 *
 */

import BaseTile         from "./BaseTile";
import Common           from "./Common";
import ScanlinesFilter  from "./ScanlinesFilter";

/**
 * @class
 */
export default class Tile2 extends BaseTile {
    constructor() {
        const assets = Common.assets;

        super(assets.getTexture("tile_002_bg"));

        this._screens = new PIXI.Sprite(assets.getTexture("tile_002_screens"));
        this.addChild(this._screens);

        const filter = new ScanlinesFilter(this._screens);
        this._screens.filters = [filter];

        this.view.anchor = new PIXI.Point();
    }

    update() {
        super.update();

        const filter = this._screens.filters[0];
        filter.time -= deltaTime * 4;
    }
}
